import React, { PureComponent, useEffect } from 'react';
const ReinforcementV = ({slabLength,slabThickness,slabWidth,L,E,D}) => {
    const resizeFactor= 125/slabWidth;
    const Lgap=((slabWidth-102)*resizeFactor)/(L-1);
    const dGap=(((slabLength-50)-(E*50*2))/(D+1));
    const tempLongArr=[];
    const tempEArr=[];
    const tempDArr=[];
    const [LongArr,setLongArr]=React.useState([]);
    const [eArr,setEArr]=React.useState([]);
    const [dArr,setDArr]=React.useState([]);
    useEffect(()=>{
        if(L){
            for(let i=1;i<=L-2;i++){
               tempLongArr.push( <span
                  key={i}
                    style={{
                      boxSizing: 'border-box',
                      position: "absolute",
                      bottom: `${(Lgap*i)}px`,
                      left: '0',
                      width: '100%',
                      height: '2px',
                      background: 'black'
                    }}
                  >
                      
                  </span>);
            }
            if(LongArr.length==0){
               setLongArr(tempLongArr);
            };
        }
        if(E){
            for(let i=0;i<E;i++){
             tempEArr.push(
                <span
                  key={i}
                    style={{
                      boxSizing: 'border-box',
                      position: "absolute",
                      left: `${50*resizeFactor*i}px`,
                 
                      width: '2px',
                      height: '100%',
                      background: 'black'
                    }}
                  >
                      
                  </span>
             )
            }
            for(let i=0;i<E;i++){
                tempEArr.push(
                   <span
                     key={i}
                       style={{
                         boxSizing: 'border-box',
                         position: "absolute",
                         right: `${50*resizeFactor*i}px`,
                    
                         width: '2px',
                         height: '100%',
                         background: 'black'
                       }}
                     >
                         
                     </span>
                )
               }

            if(eArr.length==0){
                setEArr(tempEArr);
             };
            if(D){
                for(let i=1;i<=D;i++){
                    tempEArr.push(
                       <span
                         key={i}
                           style={{
                             boxSizing: 'border-box',
                             position: "absolute",
                             left: `${(((E*50))+(dGap*i))*resizeFactor}px`,
                        
                             width: '2px',
                             height: '100%',
                             background: 'black'
                           }}
                         >
                             
                         </span>
                    )
                   }
            }
         
        }
    },[]);
    return ( 
    <>
     <div className='vis-container' >
     <div style={{
            width: `${resizeFactor * slabLength}px`,
            height: `${resizeFactor * slabWidth}px`,
            outline: `2px dotted black`,
            padding: `${50 * resizeFactor}px ${25* resizeFactor}px`,
            position: 'relative',
            boxSizing:'border-box',
                        }}>
  <div style={{
    position: 'absolute',
    top: `${50 * resizeFactor}px`,
    left: `${25 *resizeFactor}px`,
    right: `${25 * resizeFactor}px`,
    bottom: `${50 * resizeFactor}px`,
   // height:`${(slabWidth-100)*resizeFactor}px`,
    boxSizing:'content-box',
    pointerEvents: 'none' // To make sure it doesn't interfere with any events
  }}>
    <span
      key={0}
      style={{
        
        boxSizing: 'border-box',
        position: "absolute",
        bottom: '0',
        left: '0',
        width: '100%',
        height: '2px',
        background: 'black'
      }}
    >
        
    </span>
    {
    LongArr
    }
    <span
      key={L-1}
      style={{
        boxSizing: 'border-box',
        position: "absolute",
        top: '0',
        left: '0',
        width: '100%',
        height: '2px',
        background: 'black'
      }}
    >
        
    </span>
    {
        eArr
    }
  </div>
</div>
     </div>
    </>  );
}
 
export default ReinforcementV;